/**
 * Test ID utilities for Accordion component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for AccordionItem
 * @param value - Item value identifier
 * @returns Test ID string
 */
export const setAccordionItemTestId = (value: string): string => generateTestId("AccordionItem", value.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for AccordionTrigger
 * @param value - Item value identifier
 * @returns Test ID string
 */
export const setAccordionTriggerTestId = (value: string): string =>
  generateTestId("AccordionTrigger", value.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for AccordionContent
 * @param value - Item value identifier
 * @returns Test ID string
 */
export const setAccordionContentTestId = (value: string): string =>
  generateTestId("AccordionContent", value.replace(/\s+/g, "-").toLowerCase());
